import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-qa": "modal-text"
}
const _hoisted_2 = { class: "gfu-grid _mb-6" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-2of3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: $props.title,
    icon: "eye",
    "is-processing": _ctx.isProcessing,
    "is-visible": $data.isVisible
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link gfu-link--accent",
        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, "close")
    ]),
    default: _withCtx(() => [
      ($props.text)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString($props.text), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_text_field, {
            ref: "input",
            modelValue: $options.secretValueDisplay,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.secretValueDisplay) = $event)),
            "display-name": $props.displayName,
            "show-label": $props.showLabel,
            "read-only": false,
            "data-qa": "modal-field:DigitalCode"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "show-label"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([ 'gfu-grid__cell gfu-1of3 _pl-1 _flex _ai-c _gap-1', $props.showLabel ? '_pt-6' : '_pt-3' ])
        }, [
          (!$data.isShowingSecretValue)
            ? (_openBlock(), _createBlock(_component_icon_base_button, {
                key: 0,
                theme: "accent",
                icon: "eye",
                onClick: _withModifiers($options.toggleSecretValue, ["prevent"]),
                "data-qa": "modal-button:Show"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("show", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]))
            : (_openBlock(), _createBlock(_component_icon_base_button, {
                key: 1,
                theme: "accent",
                icon: "eye",
                onClick: _withModifiers($options.toggleSecretValue, ["prevent"]),
                "data-qa": "modal-button:Hide"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("hide", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])),
          ($data.isShowingSecretValue)
            ? (_openBlock(), _createBlock(_component_icon_base_button, {
                key: 2,
                theme: "accent",
                icon: "copy",
                onClick: _withModifiers($options.copySecretValue, ["prevent"]),
                "data-qa": `modal-button:${$data.secretValueCopied ? 'Copied' : 'Copy'}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($data.secretValueCopied ? 'copied!' : 'copy'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick", "data-qa"]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "is-processing", "is-visible"]))
}